<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">{{ 'observation-details.modal.title' | translate }}</h4>
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
       <jhi-observation-details [observationUnitId]="observationUnitId" [studyId]="studyId" [datasetId]="datasetId"></jhi-observation-details>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="cancel()">{{ 'cancel' | translate }}</button>
    </div>
</div>
